import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

export default {
    data() {
        return {
            // Sweetalert mixin
            SwalBootstrap: Swal.mixin({
                buttonsStyling: false,
                scrollbarPadding: false,
                customClass: {
                    confirmButton: 'btn btn-primary',
                    cancelButton: 'btn btn-muted'
                },
            }),
        }
    },

    components: {
        "FontAwesomeIcon": FontAwesomeIcon,
    },

    methods: {
        route,

        // Handle HTTP success responses
        handleSuccess(message, onClose = () => { }) {
            this.SwalBootstrap.fire({
                didClose: onClose,
                icon: 'success',
                showConfirmButton: false,
                text: message,
                timer: 2000,
                title: 'Success.',
            });
        },

        // Handle HTTP error responses
        handleError(message, onClose = () => { }) {
            this.SwalBootstrap.fire({
                didClose: onClose,
                icon: 'error',
                text: message,
                title: 'Error',
            });
        },

        // Prompt Confirmation
        promptConfirmation(message, onConfirm = () => { }, onCancel = () => { }) {
            this.SwalBootstrap.fire({
                confirmButtonText: 'Confirm',
                icon: 'warning',
                showCancelButton: true,
                text: message,
                title: 'Confirmation',
            }).then((result) => {
                result.value ? onConfirm() : onCancel();
            });
        },
    },
}
